// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layer-preview-image[data-v-f5c40364]{max-width:100px;max-height:1.5em;object-fit:cover}.pointing-up[data-v-f5c40364]{position:relative;bottom:.75em}.c-layer-handle[data-v-f5c40364]{cursor:grab}.c-layer-handle[data-v-f5c40364]:not(:hover){opacity:.5}.layer-icon[data-v-f5c40364]{transition:.2s}.layer-icon.is-open[data-v-f5c40364]{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
